import { defineStore } from 'pinia'
import { ElMessage } from 'element-plus'
import { authAPI } from '@/api'
import socketService from '@/utils/socket'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        token: localStorage.getItem('auth_token') || null,
        isAuthenticated: false
    }),

    actions: {
        async login(credentials) {
            try {
                const response = await authAPI.login(credentials)

                if (response.success) {
                    const { token, user } = response.data

                    this.token = token
                    this.user = user
                    this.isAuthenticated = true

                    localStorage.setItem('auth_token', token)
                    localStorage.setItem('user_info', JSON.stringify(user))

                    // 建立WebSocket连接
                    socketService.connect(token)

                    ElMessage.success('登录成功')
                    return { success: true }
                } else {
                    throw new Error(response.message)
                }
            } catch (error) {
                const message = error.response?.data?.message || '登录失败'
                ElMessage.error(message)
                return { success: false, message }
            }
        },

        logout() {
            // 断开WebSocket连接
            socketService.disconnect()

            this.user = null
            this.token = null
            this.isAuthenticated = false

            localStorage.removeItem('auth_token')
            localStorage.removeItem('user_info')

            ElMessage.success('已安全退出')
        },

        async initializeAuth() {
            const token = localStorage.getItem('auth_token')
            const userInfo = localStorage.getItem('user_info')

            if (token && userInfo) {
                this.token = token
                this.user = JSON.parse(userInfo)
                this.isAuthenticated = true

                // 重新建立WebSocket连接
                socketService.connect(token)

                // 验证token是否有效
                try {
                    const response = await authAPI.getMe()
                    if (response.success) {
                        this.user = response.data
                    }
                } catch (error) {
                    console.error('验证token失败:', error)
                    this.logout()
                }
            }
        }
    }
})